import React, { useMemo } from "react";
import styles from "../screens/admin/IncidenciasEdificio.module.css";

/*
  ResumenIncidencias: componente reutilizable de KPIs de incidencias.
  - Puede recibir 'stats' precomputado: { total, reported, inProgress, resolved }
  - O puede recibir 'items' y (opcional) 'statusMap' para computar los KPIs.
    statusMap por defecto cubre variantes comunes: Reportada/open, En Proceso/in_progress, Resuelta/closed
*/
const ResumenIncidencias = ({ stats, items, statusMap }) => {
  const computed = useMemo(() => {
    // Si nos pasan stats directamente, lo usamos tal cual
    if (stats && typeof stats === "object") {
      const safe = {
        total: Number(stats.total || 0),
        reported: Number(stats.reported || 0),
        inProgress: Number(stats.inProgress || 0),
        resolved: Number(stats.resolved || 0),
      };
      return safe;
    }

    // Si no hay items, devolvemos ceros
    if (!Array.isArray(items)) {
      return { total: 0, reported: 0, inProgress: 0, resolved: 0 };
    }

    // Mapa de estados por defecto que soporta ambas nomenclaturas
    const map = {
      reported: ["Reportada", "open"],
      inProgress: ["En Proceso", "in_progress"],
      resolved: ["Resuelta", "closed"],
      ...(statusMap || {}),
    };

    const getStatus = (it) => it?.status;

    const total = items.length;
    const reported = items.filter((it) => map.reported.includes(getStatus(it))).length;
    const inProgress = items.filter((it) => map.inProgress.includes(getStatus(it))).length;
    const resolved = items.filter((it) => map.resolved.includes(getStatus(it))).length;

    return { total, reported, inProgress, resolved };
  }, [stats, items, statusMap]);

  return (
    <div className={styles.statsSection}>
      <h2 className={styles.statsTitle}>Resumen de Incidencias</h2>
      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <div className={styles.statNumber}>{computed.total}</div>
          <div className={styles.statLabel}>Total</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statNumber}>{computed.reported}</div>
          <div className={styles.statLabel}>Reportadas</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statNumber}>{computed.inProgress}</div>
          <div className={styles.statLabel}>En Proceso</div>
        </div>
        <div className={styles.statCard}>
          <div className={styles.statNumber}>{computed.resolved}</div>
          <div className={styles.statLabel}>Resueltas</div>
        </div>
      </div>
    </div>
  );
};

export default ResumenIncidencias;
